module.exports = __webpack_public_path__ + "static/media/Inter-Medium.e9a0a23d.eot";